const variants = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK: 'dark',
  DANGER: 'danger',
};

export default variants;
